import styled from 'styled-components';
import ds from 'designsystem';

const UnderlineDots = styled.div`
    width: 100%;
    position:absolute;
    height: 2px;
    bottom: -3px;
    left:0;
    background-image: radial-gradient(${ds.brand('text')} 2px, ${ds.brand('white')} 2px);
    background-size: 5px 10px;
    opacity: 0.55;
    z-index: 10;
    ${({ offset }) => (offset ? `top: ${offset}px;` : '')}
`;

export default UnderlineDots;



// WEBPACK FOOTER //
// ./src/blocks/Form/UnderlineDots.jsx